import React from "react";

import { SizeType } from "antd/es/config-provider/SizeContext";
import Select from "antd/es/select";
import { useIntl } from "react-intl";

import { RouteType } from "@mapmycustomers/shared/enum/routes/RouteType";
import { Labeled, SelectField } from "@mapmycustomers/ui";

import styles from "./CommonStyles.module.scss";

interface Props {
  onChange: (visitOrder: RouteType) => void;
  size?: SizeType;
  value: RouteType;
}

const VisitOrder = ({ onChange, size, value }: Props) => {
  const intl = useIntl();

  return (
    <Labeled
      label={intl.formatMessage({
        id: "createRouteForm.field.visitOrder",
        defaultMessage: "* Visit Order",
        description: "Visit order field on the Create Route form",
      })}
    >
      <SelectField<RouteType>
        className={styles.fullWidth}
        dropdownMatchSelectWidth={false}
        onChange={onChange}
        size={size}
        value={value}
      >
        <Select.Option value={RouteType.OPTIMIZED}>
          {intl.formatMessage({
            id: "createRouteForm.field.visitOrder.option.optimize",
            defaultMessage: "Optimize Route",
            description: "Optimize Route option of the Visit order field on the Create Route form",
          })}
        </Select.Option>
        <Select.Option value={RouteType.ORDERED}>
          {intl.formatMessage({
            id: "createRouteForm.field.visitOrder.option.ordered",
            defaultMessage: "Visit Route in order",
            description:
              "Visit Route in order option of the Visit order field on the Create Route form",
          })}
        </Select.Option>
      </SelectField>
    </Labeled>
  );
};

export default VisitOrder;
